import { TableCell } from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";
import { IOptionDomainTableReport } from "../../../Interfaces/optionDomain";
import Loading from "../../../Components/Loading/Loading";
import Button from "../../../Components/Button";
import { IAdditional } from "../../TableTemplate/tableTemplate";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteOptionDomain } from "../../../Requests/optionDomain";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import { Edit } from "@mui/icons-material";
import { useAppDispatch } from "../../../App/hooks";
import {
  setAddEditOptionDomainFormValues,
  setIsOptionDomainAddEditOpen,
} from "../../../Features/OptionDomain/optionDomainSlice";

const AdditionalHeader: React.FC = ({}) => {
  return (
    <>
      <TableCell />
      <TableCell />
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IOptionDomainTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [loading, setLoading] = useState(false);

  const dispatch = useAppDispatch();

  const cancelHandler = () => {
    setLoading(true);
    deleteOptionDomain(row.id)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const editHandler = () => {
    dispatch(setIsOptionDomainAddEditOpen(true));
    dispatch(
      setAddEditOptionDomainFormValues({
        ...row,
        dividendYield: parseFloat(
          row.dividendYield?.toString().replaceAll(",", "") || "0"
        ),
        // maxMoneyness: parseFloat(row.maxMoneyness?.toString().replaceAll(",","") || "0"),
        // minCoverage: parseFloat(row.minCoverage?.toString().replaceAll(",","") || "0"),
        // minDelta: parseFloat(row.minDelta?.toString().replaceAll(",","") || "0"),
        minLastTradeVolume: parseFloat(
          row.minLastTradeVolume?.toString().replaceAll(",", "") || "0"
        ),
        remainingDayMax: parseFloat(
          row.remainingDayMax?.toString().replaceAll(",", "") || "0"
        ),
        roundingFactor: parseFloat(
          row.roundingFactor?.toString().replaceAll(",", "") || "0"
        ),
        // tolerance: parseFloat(row.tolerance?.toString().replaceAll(",","") || "0"),
        volatility: parseFloat(
          row.volatility?.toString().replaceAll(",", "") || "0"
        ),
        avg30Bubble: parseFloat(
          row.avg30Bubble?.toString().replaceAll(",", "") || "0"
        ),
        std30Bubble: parseFloat(
          row.std30Bubble?.toString().replaceAll(",", "") || "0"
        ),
        minCalculationBubble: parseFloat(
          row.minCalculationBubble?.toString().replaceAll(",", "") || "0"
        ),
      })
    );
  };

  return (
    <>
      <TableCell>
        <Button
          text={<Edit />}
          variant="contained"
          onClick={editHandler}
          className="table-btn"
        />
      </TableCell>
      <TableCell>
        <Button
          text={
            loading ? (
              <Loading size={16} className="!text-white" />
            ) : (
              <DeleteIcon />
            )
          }
          variant="contained"
          onClick={cancelHandler}
          className="table-btn"
        />
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IOptionDomainTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
